import axios from "axios";
import API_BASE from "../config/apiBase";
import { auth } from "../firebase/firebase-config";

export const normalizeMetroPhone = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  return digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
};

export const validateMetroDetails = ({ phoneNumber, homeAddress }) => {
  const errors = {};
  const phone = normalizeMetroPhone(phoneNumber);
  const address = String(homeAddress || "").trim();

  if (!String(phoneNumber || "").trim()) {
    errors.phoneNumber = "Enter your phone number.";
  } else if (!/^\d{10}$/.test(phone) || /[^\d\s()+.-]/.test(phoneNumber)) {
    errors.phoneNumber = "Enter a 10-digit US phone number, with an optional +1 country code.";
  }

  if (!address) {
    errors.homeAddress = "Enter your home address.";
  } else if (address.length < 10 || !/[a-z]/i.test(address) || !/\b\d{5}(?:-\d{4})?\b/.test(address)) {
    errors.homeAddress = "Enter your full street address, city, state, and ZIP code.";
  }

  return errors;
};

export const getMetroRequestHeaders = async () => {
  if (!auth.currentUser) {
    const error = new Error("Please sign in again to check availability.");
    error.code = "METRO_AUTH_REQUIRED";
    throw error;
  }
  return { Authorization: `Bearer ${await auth.currentUser.getIdToken()}` };
};

export const getMetroStatus = async ({ signal } = {}) => {
  const { data } = await axios.get(`${API_BASE}/api/metro/status`, {
    signal,
    timeout: 30000,
    headers: await getMetroRequestHeaders(),
  });
  if (typeof data?.configured !== "boolean") throw new Error("Availability service is unavailable.");
  return data;
};

export const checkMetroEligibility = async (details, { signal } = {}) => {
  const { data } = await axios.post(`${API_BASE}/api/metro/eligibility`, details, {
    signal,
    timeout: 30000,
    headers: { "Content-Type": "application/json", ...await getMetroRequestHeaders() },
  });

  if (typeof data?.eligible !== "boolean") {
    throw new Error("The eligibility service did not return a confirmed result.");
  }

  return {
    eligible: data.eligible,
    message: typeof data.message === "string" ? data.message : "",
    referenceId: typeof data.referenceId === "string" ? data.referenceId : "",
    checkedAt: typeof data.checkedAt === "string" ? data.checkedAt : "",
    serviceLevel: typeof data.serviceLevel === "string" ? data.serviceLevel : "",
    waitlistAvailable: data.waitlistAvailable === true,
  };
};
